import { HStack, Icon, IconButton, Text, Tooltip } from '@chakra-ui/react';
import { TbPlus } from 'react-icons/tb';
import CopyButton from '../CopyButton';

interface MfgPartNumberWithCopyProps {
    partNumber: string;
    /** Extra alternate count to show as +N after the primary. */
    alternateCount?: number;
    fontSize?: string;
    fontWeight?: string;
    color?: string;
    /**
     * When set, shows a '+' icon (same chrome as copy) that opens the
     * part-number editor modal.
     */
    onManageClick?: () => void;
}

const PlusIcon = TbPlus as React.ElementType;

const MfgPartNumberWithCopy = ({
    partNumber,
    alternateCount = 0,
    fontSize = 'sm',
    fontWeight = 'medium',
    color = 'gray.700',
    onManageClick,
}: MfgPartNumberWithCopyProps) => {
    return (
        <HStack spacing={0} align="center" data-table-mfg-part>
            <CopyButton
                text={partNumber}
                label="Copy mfg. part number"
                tooltipAnchor={
                    <HStack spacing={1} align="baseline">
                        <Text
                            fontSize={fontSize}
                            fontWeight={fontWeight}
                            color={color}
                            fontFamily="mono"
                        >
                            {partNumber}
                        </Text>
                        {alternateCount > 0 ? (
                            <Text fontSize="xs" color="gray.500" fontWeight="medium">
                                +{alternateCount}
                            </Text>
                        ) : null}
                    </HStack>
                }
                _hover={{ color: 'gray.600', bg: 'gray.100' }}
                minW="auto"
                h="auto"
                p={1}
            />
            {onManageClick ? (
                <Tooltip label="Additional Part Numbers" placement="top" hasArrow>
                    <IconButton
                        aria-label="Additional Part Numbers"
                        icon={<Icon as={PlusIcon} w={3} h={3} />}
                        size="xs"
                        variant="ghost"
                        color="gray.400"
                        _hover={{ color: 'gray.600', bg: 'gray.100' }}
                        minW="auto"
                        h="auto"
                        p={1}
                        onClick={(e) => {
                            e.stopPropagation();
                            onManageClick();
                        }}
                    />
                </Tooltip>
            ) : null}
        </HStack>
    );
};

export default MfgPartNumberWithCopy;
